import React from "react";

import { Tab } from "@headlessui/react";

import { classNames } from "common/functions";

function TabListNew({
  data,
  activeTab,
  tabLinks,
  tabListClass,
  tabClass,
  children,
  onChange,
}) {
  const tabListStyle = [
    "rounded-full",
    tabListClass.display || "flex justify-start lg:justify-center",
    tabListClass.length || " w-fit mx-auto",
    tabListClass.background || "bg-transparent",
    tabListClass.padding || "p-0",
    tabListClass.border || "border md:border border-bbc-neutral-600",
    tabListClass.othersClass,
  ].join(" ");

  const tabStyle = [
    "relative select-none rounded-full cursor-pointer border transition-all duration-100 ring-0 outline-none focus:ring-0 focus:outline-0 focus:outline-none text-center",
    tabClass.width || "w-fit",
    tabClass.textSize || "text-sm leading-6",
    tabClass.textFontWeight || "font-semibold",
    tabClass.padding || "py-3 px-6",
    tabClass.margin || "",
    tabClass.othersClass,
  ].join(" ");

  /* Handle Event */
  const handleOnClickTabLink = (e) => {
    e.preventDefault();
    window.history.pushState(null, null, e.target.getAttribute("data-go"));
  };

  return (
    <div className="w-full">
      <Tab.Group
        defaultIndex={activeTab || 0}
        onChange={() => onChange && onChange()}
      >
        <Tab.List className={classNames(tabListStyle)}>
          {Object.keys(data).length > 0 &&
            data.map((item, index) => (
              <Tab
                key={item.id || item}
                className={({ selected }) =>
                  classNames(
                    tabStyle,
                    selected
                      ? `${
                          tabClass.tabColorActive ||
                          "border-bbc-brand-500 text-bbc-brand-500"
                        }`
                      : ` ${
                          tabClass.tabColor ||
                          "border-transparent bg-transparent text-bbc-neutral-600 hover:text-bbc-brand-500"
                        } `
                  )
                }
                as="div"
              >
                {item.title || item}
                {Array.isArray(tabLinks) && tabLinks?.length > 0 ? (
                  <span
                    data-go={`#${tabLinks[index]}`}
                    onClick={handleOnClickTabLink}
                    className="absolute inset-0 h-full w-full"
                  ></span>
                ) : (
                  <></>
                )}
              </Tab>
            ))}
        </Tab.List>

        {children}
      </Tab.Group>
    </div>
  );
}

TabListNew.propTypes = {};
TabListNew.defaultProps = {
  tabListClass: {},
  tabClass: {},
};

export default TabListNew;
